import { render } from "./VFaq.vue?vue&type=template&id=08e5a3c6"
import script from "./VFaq.vue?vue&type=script&lang=ts"
export * from "./VFaq.vue?vue&type=script&lang=ts"

import "./VFaq.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script